import { Dispatch, SetStateAction, createContext, useContext } from 'react';

// Create a context to store the current active accordion and the function to change it
export const ActiveAccordionContext = createContext<{
  activeAccordionIndex: number;
  setActiveAccordion: Dispatch<SetStateAction<number>>;
  displaySingleOption?: boolean;
  targetedSection: string;
}>({
  activeAccordionIndex: 0,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setActiveAccordion: () => {},
  displaySingleOption: false,
  targetedSection: null,
});

export function useActiveAccordion() {
  return useContext(ActiveAccordionContext);
}

// Context for passing custom props from ArrayFieldTemplate to ArrayFieldItemTemplate in RJSF v6
export interface ArrayFieldItemContextValue {
  arrayTitle?: string;
  toolbarDirection?: 'row' | 'column';
  onItemCopyTrigger?: (currentItemIndex: number) => void;
  canCopyArrayItems?: boolean;
  itemTitleProperty?: string;
  // Accordion control settings (passed here since items are pre-rendered in v6)
  displaySingleOption?: boolean;
  activeAccordionIndex?: number;
  setActiveAccordion?: Dispatch<SetStateAction<number>>;
  targetedSection?: string;
  fieldPathId?: string;
}

export const ArrayFieldItemContext = createContext<ArrayFieldItemContextValue>({});

export function useArrayFieldItemContext() {
  return useContext(ArrayFieldItemContext);
}
